import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import {
  GatewayReliabilitySummaryDto,
  OperationalReliabilityAlertDto,
  SettlementReliabilitySummaryDto
} from '../../../_core/_model/machine-learning';
import { MachineLearningAdminService } from '../../../_core/_services/machine-learning-admin.service';

@Component({
  selector: 'app-admin-ml-operational-reliability',
  standalone: false,
  templateUrl: './admin-ml-operational-reliability.html',
  styleUrl: './admin-ml-operational-reliability.css'
})
export class AdminMlOperationalReliability implements OnInit {
  loading = false;
  error = '';
  fromDate = '';
  toDate = '';
  settlements: SettlementReliabilitySummaryDto | null = null;
  gateways: GatewayReliabilitySummaryDto | null = null;
  alerts: OperationalReliabilityAlertDto[] = [];

  constructor(private mlService: MachineLearningAdminService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.error = '';
    forkJoin({
      settlements: this.mlService.getSettlementReliabilitySummary(this.fromDate || null, this.toDate || null),
      gateways: this.mlService.getGatewayReliabilitySummary(this.fromDate || null, this.toDate || null),
      alerts: this.mlService.getOperationalReliabilityAlerts()
    }).subscribe({
      next: result => {
        this.settlements = result.settlements.data;
        this.gateways = result.gateways.data;
        this.alerts = result.alerts.data || [];
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error.error?.error?.details || error.error?.message || error.message || 'Unable to load operational reliability.';
        this.loading = false;
      }
    });
  }

  badgeClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'low': case 'healthy': return 'text-bg-success';
      case 'moderate': case 'watch': return 'text-bg-warning text-dark';
      case 'high': return 'text-bg-danger';
      case 'critical': return 'text-bg-dark';
      default: return 'text-bg-light text-dark border';
    }
  }

  alertClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'critical': return 'alert-danger';
      case 'high': case 'warning': return 'alert-warning';
      default: return 'alert-info';
    }
  }
}
